import React, {useState} from 'react';
import {FiArrowLeft} from 'react-icons/fi';
import {Link} from 'react-router-dom';

import api from '../../services/api';
import {useToasts} from 'react-toast-notifications'

import logo from '../../assets/fullLogo.png';
import './styles.css';

function RecoverPassword() {
    const {addToast} = useToasts()
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        setSending(true);
        e.preventDefault();

        await api.post('recover', {
            email,
        }).then(response => {
            addToast('Email de recuperação enviado!', {
                appearance: 'success',
                autoDismiss: true,
            });
            setEmail('');
            setSending(false);
        }).catch(e => {
            addToast(e.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
            });
            setSending(false);
        })
    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136}/>
                <nav id="menu">
                    <Link to="/">
                        <FiArrowLeft/>
                        Voltar para home
                    </Link>
                </nav>
            </header>
            <form onSubmit={handleSubmit}>
                <h1>Recuperação de senha</h1>
                <fieldset>
                    <legend>
                        <h2>Informe seus dados</h2>
                    </legend>
                    <div className="field">
                        <label htmlFor="email">
                            Email cadastrado
                        </label>
                        <input
                            type="text"
                            placeholder="Digite seu email..."
                            id="email"
                            value={email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.currentTarget.value)}
                        />
                    </div>
                </fieldset>
                <button type="submit" disabled={sending}>Recuperar</button>
            </form>
        </div>
    );
}

export default RecoverPassword;
